import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";

/** `en.json` is the source locale; the other languages land in Phase 6. */
export const SOURCE_LANGUAGE = "en";

void i18next.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: SOURCE_LANGUAGE,
  fallbackLng: SOURCE_LANGUAGE,
  interpolation: { escapeValue: false }, // React already escapes
});

export { i18next };
